import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "../router";
import state from "../store/index";
import { Loading, Message } from "element-ui";
axios.defaults.withCredentials = false;
Vue.use(VueAxios, axios);
let baseurl =
  process.env.NODE_ENV === "production"
    ? "https://train-service-api.procaregroup.com"
    : "/back";
export const upload_url =
  process.env.NODE_ENV === "production"
    ? "https://train-service-api.procaregroup.com/v1/common/UploadFile"
    : "https://train-service-api.procaregroup.com/v1/common/UploadFile";
export const imgUrl =
  process.env.NODE_ENV === "production"
    ? "https://train-service-cdn.oss-cn-shenzhen.aliyuncs.com/"
    : "https://train-service-cdn.oss-cn-shenzhen.aliyuncs.com/";

export let apiCollection = Vue.axios.create({
  method: "GET",
  baseURL: baseurl,
});

export let apiResource = Vue.axios.create({
  method: "POST",
  baseURL: baseurl,
});
export let apiFormSubmit = Vue.axios.create({
  method: "POST",
  baseURL: baseurl,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});
export let apiPut = Vue.axios.create({
  method: "PUT",
  baseURL: baseurl,
});
export let apiDelete = Vue.axios.create({
  method: "DELETE",
  baseURL: baseurl,
});

const axiosInstace = [
  apiCollection,
  apiResource,
  apiFormSubmit,
  apiDelete,
  apiPut,
];

axiosInstace.forEach((item) => {
  let loadingInstance = Loading.service();
  item.defaults.withCredentials = false;
  item.interceptors.response.use(
    (response) => {
      loadingInstance.close();
      return response.data;
    },
    (error) => {
      if (error.response.status == 401) {
        console.log(error.response.status);
        // Message.warning ('请到个人中心页面登录！');
        localStorage.removeItem("X-Access-Token");
      }
      if (error && error.response) {
        loadingInstance.close();
        //   localStorage.removeItem('X-Access-Token')
        return error.response.data.error;
      }
    }
  );
  loadingInstance.close();
});



// WEBPACK FOOTER //
// ./src/api/index.js